var React = require('react');

function BgPageBannerV2BottomInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#2c4965","d":"M0,537.93V686.81l457.79,179c9.13,3.55,19.77,9.34,31.4,11.49h19.06c12.39-2.13,24.91-7.85,34.09-11.43L1366,546.05v-8.12Z","transform":"translate(0 -537.93)"}));
}

BgPageBannerV2BottomInline.defaultProps = {"aria-hidden":"true","data-name":"Calque 1","viewBox":"0 0 1366 339.42"};

module.exports = BgPageBannerV2BottomInline;

BgPageBannerV2BottomInline.default = BgPageBannerV2BottomInline;
